module.exports = __webpack_public_path__ + "3f6bb054bc336ff292da9c709e5f024c.pdf";